import React, { Component } from "react";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import connect from "react-redux/es/connect/connect";
import { trimFormData } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import {
  MOBILE_USER_ACTIVITY_LOG_DETAILS,
  MOBILE_APP_USER_MANAGEMENT,
} from "../../../../navigation/routes";

import TransactionHistoryView from "./MobileUsersActivityLogView";
import {
  getMobileAppUserActivityLogs,
  updateRowsPerPageOfUsersActivityLog,
  updateCurrentPageOfUsersActivityLog,
  //
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
} from "../../../../store/mobileAppUserManagement/mobileAppUserManagementActions";

class MobileUsersActivityLogContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPageOfUsersActivityLog: this.props.currentPageOfUsersActivityLog,
      rowsPerPageOfUsersActivityLog: this.props.rowsPerPageOfUsersActivityLog,
    };

    //
    this.handleTableRowsChange = this.handleTableRowsChange.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    //
  }

  componentDidUpdate(prevProps, prevStates) {
    this.handleStateUpdateOnComponentUpdate(prevProps, prevStates);
  }

  handleStateUpdateOnComponentUpdate = (prevProps, prevStates) => {
    if (
      prevStates?.rowsPerPageOfUsersActivityLog !==
      this.props?.rowsPerPageOfUsersActivityLog
    ) {
      this.setState((prev) => {
        return {
          ...prev,
          rowsPerPageOfUsersActivityLog:
            this.props.rowsPerPageOfUsersActivityLog,
        };
      });
    }
    if (
      prevStates?.currentPageOfUsersActivityLog !==
      this.props?.currentPageOfUsersActivityLog
    ) {
      this.setState((prev) => {
        return {
          ...prev,
          currentPageOfUsersActivityLog:
            this.props.currentPageOfUsersActivityLog,
        };
      });
    }
  };

  componentDidMount() {
    //call fetch list api
    this.fetchActivityLogsList();
  }

  componentWillUnmount() {
    this.handleResetReduxState();
  }

  handleResetReduxState = () => {
    const location = window?.location?.pathname;

    if (!location?.includes(MOBILE_USER_ACTIVITY_LOG_DETAILS)) {
      const data = { label: "10", value: 10 };
      this.props?.updateRowsPerPageOfUsersActivityLog(data);
      this.props?.updateCurrentPageOfUsersActivityLog(1);
    }

    if (!location?.includes(MOBILE_APP_USER_MANAGEMENT)) {
      //--------------------------reset redux rowsPerPage state when unmounting
      const resetRowsPerPageData = { label: "10", value: 10 };
      this.props?.updateRowsPerPage(resetRowsPerPageData);
      this.props?.updateCurrentPage(1);
      //--------------------------reset redux fields state when unmounting
      const resetFields = { searchString: "" };
      this.props.updateSearchFilters(resetFields);
    }
  };

  //--------------------page handling

  handleTableRowsChange = (value) => {
    this.setState(
      (prev) => ({
        ...prev,
        rowsPerPageOfUsersActivityLog: value,
        currentPageOfUsersActivityLog: 1,
      }),
      () => {
        this.fetchActivityLogsList();
      }
    );
  };

  handleChangePage = (page) => {
    this.setState(
      (prev) => ({ ...prev, currentPageOfUsersActivityLog: page }),
      () => {
        this.fetchActivityLogsList();
      }
    );
  };

  //--------------------api call

  fetchActivityLogsList = (
    page = this.state.currentPageOfUsersActivityLog,
    limit = this.state.rowsPerPageOfUsersActivityLog?.value
  ) => {
    const userId = this.props.match?.params?.id;

    const data = {
      userId: userId,
    };

    this.props.getMobileAppUserActivityLogs(data, page, limit);
  };

  render() {
    const rowsPerPageDropDownOptions = [
      { label: "10", value: 10 },
      { label: "15", value: 15 },
      { label: "20", value: 20 },
      { label: "25", value: 25 },
      { label: "30", value: 30 },
    ];

    const { mobileUserActivityLogs } = this.props;
    const { currentPageOfUsersActivityLog, rowsPerPageOfUsersActivityLog } =
      this.state;

    return (
      <TransactionHistoryView
        //list
        mobileUserActivityLogs={mobileUserActivityLogs}
        notificationId={this.notificationId}
        //all states
        currentPageOfUsersActivityLog={currentPageOfUsersActivityLog}
        rowsPerPageOfUsersActivityLog={rowsPerPageOfUsersActivityLog}
        //select input options
        rowsPerPageDropDownOptions={rowsPerPageDropDownOptions}
        //handler functions
        handleTableRowsChange={this.handleTableRowsChange}
        handleChangePage={this.handleChangePage}
        //api call
        fetchActivityLogsList={this.fetchActivityLogsList}
      />
    );
  }
}

MobileUsersActivityLogContainer.propTypes = {};

const mapStateToProps = (state) => ({
  //list
  mobileUserActivityLogs: state.mobileUserManagement.mobileUserActivityLogs,
  //page state
  currentPageOfUsersActivityLog:
    state.mobileUserManagement.currentPageOfUsersActivityLog,
  rowsPerPageOfUsersActivityLog:
    state.mobileUserManagement.rowsPerPageOfUsersActivityLog,
});

export default connect(mapStateToProps, {
  //api
  getMobileAppUserActivityLogs,
  //
  updateRowsPerPageOfUsersActivityLog,
  updateCurrentPageOfUsersActivityLog,
  //
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
})(MobileUsersActivityLogContainer);
